import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  competenciesTotalsLength: 0,
  competenciesTotals: [],
  competenciesTotal: {},
  competenciesTotalError: "",
  formError: "",
};

export default function CompetenciesTotalReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_COMPETENCIES_TOTAL:
      return { ...state, loading: action.payload };
    case actions.LOADING_COMPETENCIES_TOTAL_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_COMPETENCIES_TOTAL:
      return { ...state, saveLoading: action.payload };
    case actions.GET_COMPETENCIES_TOTAL:
      return {
        ...state,
        competenciesTotals: action.payload.competenciesTotals,
        competenciesTotalsLength: action.payload.competenciesTotalsLength,
      };
    case actions.GET_COMPETENCIES_TOTAL_BY_ID:
      return {
        ...state, competenciesTotal: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.COMPETENCIES_TOTAL_FAIL:
      return { ...state, competenciesTotalError: action.payload };
    default:
      return state;
  }
}
